<template>
  <div v-if="!page.deleted" class="reg-page-item">
    <v-btn v-if="showDelete"
           class="delete-icon"
           icon
           outlined
           color="error"
           @click="onDeleteClick">
      <v-icon small>
        mdi-delete-outline
      </v-icon>
    </v-btn>
    <v-btn class="page-btn" outlined color="primary" @click="onPageClick">
      P{{ index + 1 }}
    </v-btn>
    <small v-if="isNotImage" class="page-pdf">PDF</small>
  </div>
</template>

<script>
export default {
  name: 'RegDocumentPageItem',
  props: {
    page: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNotImage() {
      return !String(this.page.type).startsWith('image/')
    }
  },
  methods: {
    onDeleteClick() {
      this.$emit('delete', this.page)
    },
    onPageClick() {
      if (this.page.file) {
        this.$toasted.error('Este documento ainda não foi enviado, salve o formulário para poder abrir o arquivo.')
        return
      }
      this.$emit('click', this.page)
    }
  }
}
</script>
<style lang="scss">
.reg-page-item {
  z-index: 1;
  position: relative;
  height: 56px;
  width: 50px;
  min-width: 50px;
  padding: 0;
  margin: 5px 8px 8px 5px;
  .page-btn {
    z-index: 100;
    position: absolute;
    height: 56px !important;
    width: 50px !important;
    min-width: 50px !important;
    padding: 0px;
    margin: 0px;
  }
  .page-pdf {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 8px;
    z-index: 100;
    padding: 2px;
    pointer-events: none;
    user-select: none;
  }
  .delete-icon {
    z-index: 200;
    position: absolute;
    top: -10px;
    right: -10px;
    margin: 0;
    padding: 0;
    height: 30px;
    width: 30px;
    min-width: 30px;
    background-color: white !important;
    i {
      font-size: 14px !important;
    }
  }
}

</style>
